import React, { useState } from 'react';
import Swal from 'sweetalert2';
import PropTypes from 'prop-types';
import { FaExclamationTriangle } from 'react-icons/fa';
import { publisherAPI } from '../../../../utils/api';

function PublisherCreate({ publisher=null, onClose, onSubmit }){
  const [formData,setFormData]=useState({ name:'', contactName:'', phone:'', email:'', address:'', taxExempt:false, username:'', password:'' });
  const [errors,setErrors]=useState({});
  const [submitting,setSubmitting]=useState(false);
  const isEdit=!!publisher;

  React.useEffect(()=>{
    if(publisher){ setFormData({ name:publisher.name||'', contactName:publisher.contactName||'', phone:publisher.phone||'', email:publisher.email||'', address:publisher.address||'', taxExempt: !!publisher.taxExempt, username: publisher.username||'', password:'' }); }
  },[publisher]);

  const validateField=(k,v)=>{
    switch(k){
      case 'name': return v.trim()? '': 'Name required';
      case 'email': return v && !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(v)? 'Invalid email':'';
      case 'username': return v.trim()? '':'Username required';
      case 'password': return isEdit? '' : (v.length<6? 'Min 6 chars':'');
      default:return '';
    }
  };
  const handleChange=e=>{ const {name,value}=e.target; setFormData(p=>({...p,[name]:value})); setErrors(p=>({...p,[name]:validateField(name,value)})); };
  const validateForm=()=>{ const e={}; Object.keys(formData).forEach(k=>{ const msg=validateField(k,formData[k]); if(msg) e[k]=msg; }); setErrors(e); return !Object.keys(e).length; };

  const handleSubmit=async ev=>{
    ev.preventDefault(); if(!validateForm()) return Swal.fire('Validation','Fix errors','error');
    setSubmitting(true);
    try{
      const payload={...formData}; if(isEdit && !payload.password) delete payload.password; // optional
      if(isEdit) await publisherAPI.update(publisher.id,payload); else await publisherAPI.create(payload);
      Swal.fire('Success', isEdit?'Publisher updated':'Publisher created','success');
      window.dispatchEvent(new CustomEvent('publisher:updated'));
      onSubmit&&onSubmit(); onClose&&onClose();
    }catch(err){ Swal.fire('Error', err?.response?.data?.error||'Failed','error'); }
    finally{ setSubmitting(false);} };

  return(
    <form onSubmit={handleSubmit} className="eduss-district-create-form">
      {['name','contactName','phone','email','address','username','password'].map(f=>{
        const labelMap={name:'Name',contactName:'Contact Name',phone:'Phone',email:'Email',address:'Address',username:'Username',password:'Password'};
        return (
          <div className="eduss-district-create-field" key={f}>
            <label htmlFor={f}>{labelMap[f]}{f==='name'? <span className="eduss-district-create-required">*</span>:null}</label>
            {f==='password'? (
              <input type="password" id={f} name={f} placeholder={`Enter ${labelMap[f].toLowerCase()}`} value={formData[f]} onChange={handleChange} disabled={submitting} className={errors[f]?'eduss-district-create-input error':'eduss-district-create-input'} />
            ): f!=='address'? (
              <input type="text" id={f} name={f} placeholder={`Enter ${labelMap[f].toLowerCase()}`} value={formData[f]} onChange={handleChange} disabled={submitting} className={errors[f]?'eduss-district-create-input error':'eduss-district-create-input'} />
            ):(
              <textarea id={f} name={f} placeholder="Enter address" value={formData[f]} onChange={handleChange} disabled={submitting} className={errors[f]?'eduss-district-create-input error':'eduss-district-create-input'} />
            )}
            {errors[f] && <div className="eduss-district-create-error"><FaExclamationTriangle/> {errors[f]}</div>}
          </div>
        );})}
      {/* Tax Exempt toggle */}
      <div className="eduss-district-create-field">
        <label>Tax Exempt</label>
        <select name="taxExempt" value={formData.taxExempt? 'yes':'no'} onChange={e=>setFormData(p=>({...p,taxExempt:e.target.value==='yes'}))} disabled={submitting}>
          <option value="no">No</option>
          <option value="yes">Yes</option>
        </select>
      </div>
      <div className="eduss-district-create-actions">
        <button type="button" onClick={onClose} className="eduss-district-create-btn cancel" disabled={submitting}>Cancel</button>
        <button type="submit" className="eduss-district-create-btn submit" disabled={submitting}>{isEdit? 'Update Publisher':'Create Publisher'}</button>
      </div>
    </form>
  );
}

PublisherCreate.propTypes={ publisher:PropTypes.object, onClose:PropTypes.func, onSubmit:PropTypes.func };
export default PublisherCreate;
